import React, { useState, useEffect } from "react"
import { Outlet } from 'react-router-dom';
import LogoAd3 from "../assets/images/AD3_LOGO-OK.png";
import flechaUp from "../assets/icons/flecha-hacia-arriba.svg";
import lista from "../assets/icons/lista.svg";
import cerrar from "../assets/icons/cerrar.svg";
import { Link } from 'react-scroll';


const Layout = () => {
    const [hasScrolled, setHasScrolled] = useState(false);
    const [end, setEnd] = useState("proyectos")
    const [menu, setMenu] = useState(false);
    const [click, setClick] = useState(false);
    const [current, setCurrent] = useState(null);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        setEnd("proyectos")
    };

    useEffect(() => {
        console.log(window)
        const handleScroll = () => {
            const currentPosition = window.scrollY;
            setCurrent(currentPosition)

            setHasScrolled(currentPosition > 0);

        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
            setClick(false)
        };


    }, []);
    useEffect(() => {
        if (!click) {
            if (window.innerWidth <= 1058) {
                //Para mobile
                if (current < 300) {
                    setEnd("proyectos");
                } else if (current >= 300 && current < 1000 && !click) {
                    setEnd("acerca");
                    setClick(false)
                } else if (current >= 1000 && current < 2500) {
                    setEnd("contacta");
                }
            } else {
                //Para web
                if (current < 900) {
                    setEnd("proyectos");
                } else if (current >= 900 && current < 2000 && !click) {
                    setEnd("acerca");
                    setClick(false)
                } else if (current >= 2000 && current < 2500) {
                    setEnd("contacta");
                }
            }
        }
    }, [current, click]);
    return (
        <div>
            <nav style={hasScrolled || menu ? navStyle : navStyleScroll}>
                {window.innerWidth <= 1058 ? <img src={LogoAd3} alt="Logo Ad3" width={50} style={{ position: "absolute", margin: 2 }} /> : ""}
                {window.innerWidth <= 1058 ? <div style={window.innerWidth <= 1058 ? filaHidden : fila}>
                    {menu ? <img src={cerrar} alt="Cerrar Ad3" width={14} style={imgMenu} onClick={() => setMenu(!menu)} /> :
                        <img src={lista} alt="Menú Ad3" width={16} style={imgMenuBurguer} onClick={() => setMenu(!menu)} />
                    }
                </div> : <ul style={window.innerWidth <= 1058 ? filaHidden : fila}>
                    <div>
                        <Link to="proyectos"
                            smooth={true}
                            duration={500}
                            offset={-100} style={
                                end === "proyectos" ? activeLink : link
                            } onClick={() => {
                                setClick(true)
                                setEnd("proyectos")
                            }}>Proyectos</Link>
                    </div>
                    <div>
                        <Link to="acerca"
                            smooth={true}
                            duration={500}
                            offset={-100} style={
                                end === "acerca" ? activeLink : link
                            } onClick={() => {
                                setClick(false)
                                setEnd("acerca")
                            }} activeClass="active">Acerca de</Link>
                    </div>
                    <div>
                        <Link to="contacta"
                            smooth={true}
                            duration={500}
                            offset={-100} style={
                                end === "contacta" ? activeLink : link
                            } onClick={() => {
                                setEnd("contacta")
                                setClick(true)
                            }}>Contacto</Link>
                    </div>
                </ul>}

                <ul style={menu ? filaMobile : filaMobileHidden}>
                    <div>
                        <Link to="proyectos"
                            smooth={true}
                            duration={500}
                            offset={-50} style={
                                end === "proyectos" ? activeLink : link
                            } onClick={() => {
                                setClick(true)
                                setEnd("proyectos")
                            }}>Proyectos</Link>
                    </div>

                    <div style={{ marginTop: 15 }}>
                        <Link to="acerca"
                            smooth={true}
                            duration={500}
                            offset={-50} style={
                                end === "acerca" ? activeLink : link
                            } onClick={() => {
                                setEnd("acerca")
                                setClick(false)
                            }}>Acerca de</Link>
                    </div>
                    <div style={{ marginTop: 15 }}>
                        <Link to="contacta"
                            smooth={true}
                            duration={500}
                            offset={-50} style={
                                end === "contacta" ? activeLink : link
                            } onClick={() => {
                                setEnd("contacta")
                                setClick(true)
                            }}>Contacto</Link>
                    </div>
                </ul>

            </nav>
            <div style={contLogoText}>
                <div style={contLogo}>
                    <img src={LogoAd3} alt="Logo Ad3" />

                </div>
                <h1 style={textPieLogo}>Soluciones tecnológicas a medida</h1>
            </div>
            <div style={menu ? contentMenu : content}>
                <Outlet />
            </div>
            {hasScrolled && (
                <button
                    onClick={scrollToTop}
                    style={scrollButton}
                    className="scroll-to-top"
                >
                    <img src={flechaUp} alt="Logo Ad3" width={20} />
                </button>
            )}
        </div>
    )
}
export default Layout;
const navStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    zIndex: 1,
    backgroundColor: '#f3f3f3',
    padding: '10px',
    transition: 'all 0.5s ease-in-out',
    opacity: 1,
};
const navStyleScroll = {
    ...navStyle,
    backgroundColor: 'transparent',
};

const contLogo: any = {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 15
}
const contLogoText: any = {
    width: "100%",
    display: window.innerWidth <= 1058 ? "none" : "block"
}
const fila: any = {
    display: "flex",
    gap: 6,
    marginRight: 30,
    marginTop: 5,
    justifyContent: "flex-end",
}
const filaHidden: any = {
    ...fila,
    justifyContent: "flex-end",
}
const filaMobile: any = {
    gap: 12,
    marginRight: 60,
    marginLeft: -30,
    transition: 'all 0.4s ease-in-out',
    marginTop: 40,
    marginBottom: 20
}
const filaMobileHidden: any = {
    display: "none",
    transition: 'all 0.4s ease-in-out',
    marginBottom: 20
}

const link: any = {
    textDecoration: 'none',
    color: "#000",
    padding: 5,
    transition: 'all 0.4s ease-in-out',
    cursor: "pointer"
}
const activeLink: any = {
    background: "#000",
    color: "#ffffff",
    textDecoration: 'none',
    padding: 5,
    transition: 'all 0.4s ease-in-out',
    cursor: "pointer"
}
const textPieLogo: any = {
    textAlign: "center",
    marginLeft: 20
}
const content: any = {
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: 50
}
const contentMenu: any = {
    ...content,
    marginTop: 50
}
const imgMenu: any = {
    transition: 'all 0.9s ease-in-out',

}
const imgMenuBurguer: any = {
    transition: 'all 0.9s ease-in-out',

}
const scrollButton = {
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    background: 'white',
    color: '#fff',
    borderRadius: '50%',
    padding: '10px',
    border: 'none',
    cursor: 'pointer',
    zIndex: 1000,
    alignItems: "center",
    alignSelf: "center",
    alignContent: "center"
};


